// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3dh4A","name":"Header_name__2ml87","birthday":"Header_birthday__1V7Ax","skeleton":"Header_skeleton__2tJxA"};